// extracted by mini-css-extract-plugin
export default {"form":"seo_form__pbx+0","title":"seo_title__NxdYf","description":"seo_description__AZ1tZ","result":"seo_result__c2KO4"};